import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function LoginDeliveryView() {
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext); 
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // 🌐 CAMBIO CLAVE: Apuntamos directo al archivo físico en cPanel para evitar el choque del config con el enrutador
      const response = await fetch('https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ correo, contrasena })
      });
      const data = await response.json();
    
      if (!response.ok) {
        // 🔬 Si el backend nos mandó la depuración del error 500, la exponemos directamente
        if (data.mensaje_real) {
          setError(`Error PHP: ${data.mensaje_real} (Línea ${data.linea} en ${data.archivo.split('/').pop()})`);
        } else {
          setError(data.error || 'Error al iniciar sesión');
        }
        return;
      }
    
      // 📝 Preparamos el objeto para el Contexto
      const usuarioParaContexto = {
        token: data.token,
        id: data.usuario.id,
        nombre: data.usuario.nombre,
        rol: data.usuario.rol
      };
    
      // 🛡️ VALIDACIÓN DE ROL
      if (usuarioParaContexto.rol !== 'delivery') {
        setError('Acceso denegado: No tienes permisos de repartidor');
        return;
      }
    
      // 🔑 Usamos la función centralizada del contexto
      login(usuarioParaContexto);
    
      // 🚀 Navegación inmediata
      navigate('/delivery');
      
    } catch (err) {
      console.error("Error en login delivery:", err);
      setError('Error de conexión con el servidor o JSON inválido');
    }  
  };

  // --- ESTILOS (Se mantienen exactamente igual a los tuyos) ---
  const containerStyle = { backgroundColor: '#000', color: '#fff', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'Arial, sans-serif' };
  const boxStyle = { backgroundColor: '#111', padding: '40px', borderRadius: '8px', boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)', width: '100%', maxWidth: '400px' };
  const inputStyle = { width: '100%', padding: '12px', marginBottom: '15px', borderRadius: '4px', border: '1px solid #444', backgroundColor: '#222', color: '#fff', fontSize: '14px' };
  const buttonStyle = { width: '100%', padding: '12px', backgroundColor: '#ff0000', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer', transition: 'background-color 0.3s ease' };

  return (
    <div style={containerStyle}>
      <div style={boxStyle}>
        <h2 style={{ color: '#ff0000', textAlign: 'center', marginBottom: '30px' }}>Clavelina-Delivery</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Correo"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            required
            style={inputStyle}
          />
          <button type="submit" style={buttonStyle}>Ingresar</button>
        </form>
        {error && <p style={{ color: '#ff4d4d', marginTop: '15px', textAlign: 'center' }}>{error}</p>}
      </div>
    </div>
  );
}

export default LoginDeliveryView;